var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Welcome","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Desktop-HD","transform":"translate(-28.000000, -1034.000000)","fill":"#000000"},React.createElement("path",{"d":"M43,1038.814 L40.2812613,1038.81581 C38.1492358,1038.81581 37.7358286,1039.83263 37.7358286,1041.32431 L37.7358286,1044.61581 L42.8212781,1044.61581 L42.1587435,1049.77238 L37.7358286,1049.77238 L37.7358286,1063 L32.4337465,1063 L32.4337465,1049.77238 L28,1049.77238 L28,1044.61581 L32.4337465,1044.61581 L32.4337465,1040.815 C32.4337465,1036.40156 35.1181851,1034 39.0374293,1034 C40.9149115,1034 42.5288242,1034.13956 43,1034.203 L43,1038.814 Z","id":"Path"}))));
}

Facebook.defaultProps = {"width":"15px","height":"29px","viewBox":"0 0 15 29","version":"1.1"};

module.exports = Facebook;

Facebook.default = Facebook;
